import { STABLECOIN } from '@common/constants/stablecoin';
import { operationRate } from '@common/utils/operationRate';

const PAYOUT_ONLY = 'payout_only';

/**
 * Moeda em que o cliente pagou a operação (a origem do pagamento): o valor total, os impostos e a
 * tarifa da tela estão nela. Vem da entrada da operação — a do app ou a entrada estrangeira da web
 * (fora do PIX). Só de saída do app, o cliente paga com o dólar da carteira (o totalValue é em
 * dólar). Sem nada disso, o pagamento foi em moeda nacional (PIX ou operação tradicional). Toda
 * tela de operação usa esta função: antes cada uma tinha a sua, e uma operação paga em dólar
 * aparecia com R$.
 *
 * @param {Object} operation
 * @returns {string} código da moeda (USD, EUR, BRL...)
 */
export function operationOriginCurrency(operation) {
  if (operation?.payInAppFiatCurrency || operation?.payInWebFiatCurrency)
    return operation.payInAppFiatCurrency || operation.payInWebFiatCurrency;

  if (operation?.stablecoinOperationType === PAYOUT_ONLY) return STABLECOIN.CURRENCIES.USD.code;

  return STABLECOIN.CURRENCIES.BRL.code;
}

/**
 * Operação stablecoin (DolsPay): banco ou natureza digital, ou com entrada/saída em stablecoin.
 * Nela não há IOF, a taxa gravada é a da perna do provedor e os valores da casa são em dólar.
 */
export function isStablecoinOperation(operation) {
  return Boolean(
    operation?.bank?.isDigitalCurrency === true || operation?.bank?.isDigitalCurrency === 'true' ||
    operation?.nature?.isDigitalCurrency === true ||
    operation?.stablecoinOperationType || operation?.payInAppFiatCurrency || operation?.payInWebFiatCurrency ||
    operation?.payInAppToken || operation?.payOutAppToken || operation?.administrative?.stableCoin?.token
  );
}

/** Taxa da operação como o cliente teve ({ base, quote, value }), ou null. */
export function operationRateOf(operation) {
  return operationRate({
    originCurrency: operationOriginCurrency(operation),
    destinationCurrency: operation?.currency?.code,
    totalValue: operation?.totalValue,
    amount: operation?.amount,
    customerRate: operation?.customerRate,
    isStablecoin: isStablecoinOperation(operation)
  });
}
